<nav class="navbar navbarcustom">
  <div class="container-fluid d-flex justify-content-between align-items-center nav-xsp0">
    <!-- Logo and Brand Name -->
    <a class="navbar-brand d-flex align-items-center">
      <span class="custom-logo">
        <img src="/assets/images/TMCV-New-Logo.png" alt="Tata Motors Commercial Vehicles" height="42" class="d-inline-block">
        &nbsp;
      </span>
      &nbsp;
      <span class="navbar-text ms-2">FleetCare</span>
    </a>
    <!-- Image at the End -->
    <img src="/assets/images/tata_Logo.png" alt="Example Image" class="d-inline-block end-image d-none d-sm-block">
  </div>
</nav>

<div class="login-container">
  <div class="background-image">
    <img src="/assets/images/dealer_login.png" alt="Background" />
  </div>

  <footer class="d-none">
    <div class="container">
      <div class="row" style="justify-content: center;">
        <div class="col-12 col-md-2 p-0" style="text-align: center;">
          <p><img src="../../../../assets/images/new-table/call.png"> &#128222; 1800 209 7979</p>
        </div>
        <div class="col-12 col-md-4 contacttxt">
          <div class="footer-contact">
            <div><img src="../../../../assets/images/new-table/addresswhite.png"></div>
            <div class="txt">
              Tata Motors Commercial Vehicles Regional Office, Eastern Express Highway, Gyan Sadhna College Service Road, Teen Hath Naka, Thane, Maharashtra - 400615
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</div>
